<template>
    <div class="w-100">

        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>
            </div>
        </div>

        <!-- Alert box -->
        <div v-show="this.v$.step[this.currentStep - 1].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep - 1].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep - 1].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-care-plan" action="care-plans/store" class="add-care-plan add-record">           
            
            <div class="card" v-if="currentStep == 1" title="Evaluation">
                <div class="card-header">
                    <h3 class="card-title">Evaluation</h3>
                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="card mb-4">
                                <div class="table-responsive">
                                    <table class="table table-vcenter card-table">
                                        <thead>
                                            <tr>
                                                <th>Created On</th>
                                                <th>Activity</th>
                                                <th>Purpose / Aim</th>
                                                <th>Method / Action Plan</th>
                                                <th>Goal Met</th>                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(intervention, index) in step[0].interventions">
                                                <td class="align-top">{{ intervention.createdAt != null ? intervention.createdAt : '--'}}</td>
                                                <td class="align-top">{{ intervention.activity != null ? intervention.activity : '--'}}</td>
                                                <td class="align-top">{{ intervention.purpose != null ? intervention.purpose : '--'}}</td>
                                                <td class="align-top">{{ intervention.method != null ? intervention.method : '--'}}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="v$.step[0].interventions.$model[index].goalMet"/>                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].interventions.$each.$response.$data[index].goalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">                            
                            
                            <div class="mb-3">
                                <div class="form-label">Evaluation</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Evaluation"
                                    value=""
                                    spellcheck="false"
                                    name="evaluation"
                                    v-model="step[0].evaluation"
                                    :class="{
                                        'is-invalid': v$.step[0].evaluation.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].evaluation.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Did the plan met its overall goal?</div>
                                <label v-for="option in resultOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="result" :value="option" v-model="step[0].evaluationResult" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].evaluationResult.$invalid}">Invalid feedback</div>
                            </div>
                            
                            
                            <div class="mb-3">
                                <div class="form-label">Signature</div>                     
                                <input
                                    type="text"
                                    class="form-control w-75 mt-2"
                                    name="reviewerSignature"
                                    placeholder="Enter your full name"
                                    v-model="step[0].reviewerSignature"
                                    :class="{'is-invalid': v$.step[0].reviewerSignature.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].reviewerSignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>                         

                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                        </div>
                    </div>

                </div>
                
                <div class="card-footer justify-content-end">                    
                    <p class="d-flex align-items-center mb-0">
                        
                        <a :href="'/care-plans/' + carePlanID" class="p-2 mx-3 d-block back-btn" id="last-back-btn">Cancel</a>
                        <a @click="onClickNext()" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>
                
            </div>

        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue, helpers} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import Multiselect from 'vue-multiselect';
import moment from 'moment';

export default {
    name: "activityCarePlanReviewComponent",
    props: ["progressBar", "pageTitle", "residentId", "userId", "carePlan", "operation"], // vue can read kebab props as camel cased vars
    components: { Multiselect },
    setup() {
        return {v$: useVuelidate()};
    },
    data() {             
        var carePlanObject = JSON.parse(this.carePlan); 
        var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + carePlanObject.id +'/6m8geptupkijwghd7xkya6wbjkrqo1wwpuuhmzzuuqhqhovy2mclfumdkccg'; // TODO: figure out why this.api_token returns undefined
        
        carePlanObject['activity_care_plan'] = JSON.parse(carePlanObject['activity_care_plan']);

        // Returs empty string when object doesn't exist 
        // options - array | string
        function returnValueFromObject(fieldName, defaultValue = "", options) {      
            // Editing
            if (!_.isEmpty(carePlanObject)) {
                return carePlanObject['activity_care_plan'][fieldName];
            } else {
                return defaultValue;
            }
        }

        return {
            currentStep: 1, 
            maxStep: 1,
            percentageComplete: 0,
            errors: 0,
            trueFalseOptions: [true,false],
            resultOptions: ['Met', 'Not Met', 'Partially Met'],
            endpoint: endpointToUse,
            carePlanID: JSON.parse(this.carePlan)['id'],
            step: [
                // Step 1 - Evaluation
                {
                    interventions: returnValueFromObject('interventions','{}'),         
                    evaluation: returnValueFromObject('evaluation'),
                    reviewerSignature: returnValueFromObject('reviewerSignature'),
                    evaluationResult: carePlanObject['evaluation_result'],

                },
            ],
            api_token: process.env.MIX_API_KEY,
        };
    },
    validations() {

        // Custom Validators
        const inArray = (array) => (value) => array.includes(value) || !helpers.req(value);
        const isDateFormat = (value) => value.match("^$|((?:[0-9]{2})?[0-9]{2})-(1[0-2]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])") || !helpers.req(value);
        const isTimeFormat = (value) => value.match("^$|^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$") || !helpers.req(value);
        const isTextWithSpecialCharacters = (value) => value.match("^[a-zA-Z0-9_ !@#$&%^*()`.+,/\\-\r\n\s\'\"]*$") || !helpers.req(value);
        const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ \s\'\"]*$") || !helpers.req(value);

        const dateType = {
            required, 
            isDateFormat, 
            $lazy: true, 
            $autoDirty: true
        };
        
        const timeType = {
            required, 
            isTimeFormat, 
            $lazy: true, 
            $autoDirty: true
        };

        // TEXT TYPES: default: 191, mid:500, long:1000
        function text(minimum = 3,maximum = 191, isRequired = false, allowSpecial = false) {
            if (allowSpecial) {
                var rule = {
                    required,
                    isTextWithSpecialCharacters,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };
            } else {
                var rule = {
                    required,
                    isTextWithSpace,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };                
            }

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }

        // ARRAY TYPES        
        function inOptions(options, isRequired = false) {
            var rule = {
                required,
                inOptions: inArray(options),
                // $lazy: true,
                // $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }
        
        // Use for types with no 'required' parameter
        function notRequired(type) {
            var validations = Object.assign({}, type);                
            delete validations['required'];
            
            return validations;
        };

        return {
            step: [
                // Step 1 - Evaluation
                {   
                    interventions: {
                        required,
                        minLength: minLength(1),
                        maxLength: maxLength(10),
                        $each: helpers.forEach({
                            goalMet: inOptions(this.trueFalseOptions)
                        })
                    },
                    evaluation: text(3, 500, true, true), 
                    evaluationResult: inOptions(this.resultOptions),                   
                    reviewerSignature: text(3, 191, true)
                },
            ],
        };
    },

    computed: {},

    methods: {
        onClickNext: function () {        
            
            // Validate fields on current step
            this.v$.step[this.currentStep - 1].$touch();

            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep - 1].$error) {

                // All steps
                if (this.currentStep < this.maxStep) {                           
                    // Proceed to next step
                    this.currentStep++;

                // Final step
                } else if (this.currentStep == this.maxStep) {
                    
                    // Initialize alerts and toast notifications for displaying message  
                    const toastError = Swal.mixin({          
                            toast: true,                
                            position: 'top-end', 
                            showConfirmButton: true, 
                        });  
                    const alertSuccess = Swal.mixin({                          
                            position: 'center', 
                            showConfirmButton: true, 
                            timer: 3000,
                            timerProgressBar: true,
                        });  

                    // Show button spinner
                    document.getElementById('submit-btn').innerHTML  = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById('submit-btn').disabled  = true;
                    document.getElementById('last-back-btn').setAttribute('style', 'display:none !important');

                   
                    var formData = {};
                    var interventions = [];
                    
                    // Loop through all steps
                    for(let i=0; i < this.maxStep; i++){ 
                        // Loop through all the step fields
                        for ( const [key,value] of Object.entries( this.step[i] ) ) {   
                            formData[key] = value;                     
                        }
                    }

                    // Add residentID, userID, type and interventions fields
                    formData['residentID'] = this.residentId;
                    formData['userID'] = this.userId;
                    formData['type'] = "Activity";             
                    formData['updateType'] = 'review';
                    
                    this.updateCarePlan(formData, toastError, alertSuccess);
                   
                }
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
            }
        },


        updateCarePlan: function(formData, toastError, alertSuccess) {           
            // Call the update endpoint
            axios.put(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            });                             
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was updated
                            this.formSuccess = true;
                            window.residentId = this.residentId;

                            alertSuccess.fire({
                                title: "Success!",
                                text: "The activity care plan has been reviewed.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/residents/"+window.residentId+"/care-plans?type=Activity";
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'error', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        }        
        
    },
};
</script>
